import { AccountState } from "Types/state";
import { GetAccountResponseErrorAction, GetAccountResponseSuccessAction } from "../dataService/actions/account";
import { AccountResponses } from "../dataService/types";

export const accountInitialState: Partial<AccountState> = {
    loading: true,
};

function account(
    state: Partial<AccountState> = accountInitialState,
    action: GetAccountResponseSuccessAction | GetAccountResponseErrorAction
): Partial<AccountState> {
    switch (action.type) {
        case AccountResponses.GetSuccess:
            return { ...action.data, loading: false };

        case AccountResponses.GetError:
            return {
                ...state,
                error: true,
            };
        default:
            return state;
    }
}

export default account;
